import TextDocument, {
  Title,
  Paragraph,
  Header,
  Footnote,
} from '../../../components/common/TextDocument';

function TermsOfService() {
  return (
    <TextDocument>
      <Title>利⽤規約</Title>
      <Header>第 1 条（⽬的）</Header>
      <Paragraph>{`1. この利⽤規約（以下「本規約」といいます。）は、丸紅フォレストリンクス株式会社（以下「当社」といいます。）が運営する、廃棄物の処理及び清掃に関する法律（以下「廃掃法」といいます。）その他関連法令上の産業廃棄物収集運搬業者・処理業者向け配⾞管理業務⾃動化サービス「ぼくらの配車さん」 （以下「本サービス」といいます。）を利⽤するユーザー（以下「ユーザー」といいます。）に適⽤されます。ユーザーは、本規約に同意の上、本サービスを利⽤します。

2. 本規約は、本サービスの利⽤条件を定めています。本サービスにユーザー登録したユーザーは全て本規約に従い、年齢や利⽤環境等の条件に応じて 、本規約の定める条件に従って本サービスを利⽤します。

3. ユーザーが本規約に同意することにより、当社との間に本契約（第2条で定義します。）が成⽴します。`}</Paragraph>
      <Header>第 2 条（定義）</Header>
      <Paragraph>{`本規約において使⽤する以下の⽤語は、以下の各号に定める意味を有します。

1. 「本契約」：本規約を契約条件として当社及びユーザーとの間で締結される、本サービスの利⽤契約を指します。

2. 「ユーザー」：本サービスのユーザー登録をしている全ての⽅を指します。

3. 「ユーザー情報」：本サービスに登録したユーザーのID及びパスワードを指します。

4. 「通信機器」： スマートフォン、タブレット端末及びコンピューター機器を指します。`}</Paragraph>
      <Header>第 3 条（ユーザー登録）</Header>
      <Paragraph>{`1. 本サービスのユーザーになろうとする⽅は、本規約の内容に同意の上、当社が定める⼿続きによりユーザー登録を⾏います。

2. ユーザーは、前項に基づき登録した情報に変更が発⽣した場合、直ちに、登録情報の変更⼿続を⾏う義務を負います。

3. 当社は、当社の裁量により、ユーザー登録を拒否する場合があります。

4. ユーザーは、本サービス上のアカウントを第三者に対して利⽤、貸与、譲渡、売買⼜は質⼊等をすることはできません。`}</Paragraph>
      <Header>第 4 条（本サービスの内容）</Header>
      <Paragraph>{`本サービスは、当社が独⾃に開発した数理最適化アルゴリズムを⽤いた配⾞業務のシステム化および配⾞計画の⾃動⽣成による廃棄物収集運搬⽀援サービスです。`}</Paragraph>
      <Header>第 5 条（利⽤料⾦）</Header>
      <Paragraph>{`1. 本サービスの利⽤料⾦は、当社が定める料⾦表に従います。

2. ユーザーは、当社が定める⽅法でのみ、本サービスに係る利⽤料⾦の決済を⾏うことができます。

3. 当社はいつでも価格を変更する権利を留保しますが、当社がユーザーの本サービス利⽤に対し特別の期間と料⾦を提⽰した場合、当社はその期間中、その料⾦が据え置かれることに同意します。提⽰期間の終了後、本サービス利⽤はその時点での料⾦で請求されます。ユーザーがこれらの変更に同意しない場合、サービスの利⽤を中⽌し、当社新規事業開発課 （contact-haisyasan@marubeni-flx.com）にEメールで（当社担当者による退会の確認と合わせて）退会を申請しなければなりません。退会する場合、現存のサービス期間あるいは⽀払い期間の終了時に本サービスが終了になり、それ以前に⽀払われたサービスに対する返⾦はありません。`}</Paragraph>
      <Header>第 6 条（ユーザー情報及び通信機器に関する管理）</Header>
      <Paragraph>{`1. ユーザーは、本サービスの提供を受けるために必要な機器、通信⼿段及び交通⼿段等の環境を全て⾃らの費⽤と責任で備えます。また、本サービスの利⽤にあたり必要となる通信費⽤は、全てユーザーの負担とします。

2. ユーザーは、ユーザー情報及び通信機器の管理責任を負います。ユーザー情報及び通信機器の管理不⼗分、使⽤上の過誤、第三者の使⽤等による損害の責任はユーザーが負い、当社は当社に故意⼜は過失のない限り⼀切の責任を負いません。

3. ユーザーは、ユーザー情報⼜は通信機器を第三者に使⽤されるおそれのある場合は、直ちに当社にその旨を連絡するとともに、当社の指⽰がある場合はこれに従います。`}</Paragraph>
      <Header>第 7 条（本サービスの提供条件）</Header>
      <Paragraph>{`当社は、メンテナンス等のために、ユーザーに通知することなく、本サービスを停⽌⼜は変更することがあります。`}</Paragraph>
      <Header>第 8 条（知的財産権等）</Header>
      <Paragraph>{`1. ユーザーが本サービス上において投稿等を⾏った場合、著作物性の有無を問わず、掲載内容の⼀部⼜は全部に関し、発⽣しうる全ての著作権（著作権法第27 条及び第28 条に定める権利を含みます。）について、⽬的を問わず、無償かつ無制限に利⽤できる権利を当社に対して許諾することについて同意します。

2. ユーザーは、⽅法⼜は形態の如何を問わず、本サービスにおいて提供される全ての情報及びコンテンツ（以下総称して「当社コンテンツ」といいます。）を著作権法に定める、私的使⽤の範囲を超えて複製、転載、公衆送信、改変その他の利⽤をすることはできません。

3. 当社コンテンツに関する著作権、特許権、実⽤新案権、商標権、意匠権その他⼀切の知的財産権及びこれらの権利の登録を受ける権利（以下総称して「知的財産権」といいます。）は、当社⼜は当社がライセンスを受けているライセンサーに帰属し、ユーザーには帰属しません。また、ユーザーは、知的財産権の存否にかかわらず、当社コンテンツについて、複製、配布、転載、転送、公衆送信、改変、翻案その他の⼆次利⽤等を⾏ってはなりません。

4. ユーザーが本条の規定に違反して問題が発⽣した場合、ユーザーは、⾃⼰の費⽤と責任において当該問題を解決するとともに、当社に何らの不利益、負担⼜は損害を与えないよう適切な措置を講じなければなりません。

5. ユーザーは、著作物となりうる掲載内容の⼀部について、当社並びに当社より正当に権利を取得した第三者及び当該第三者から権利を承継した者に対し、著作者⼈格権（公表権、⽒名表⽰権及び同⼀性保持権を含みます。）を⾏使しません。`}</Paragraph>
      <Header>第 9 条（禁⽌事項）</Header>
      <Paragraph>{`1. 当社は、ユーザーによる本サービスの利⽤に際して、以下の各号に定める⾏為を禁⽌します。
(1) 本規約に違反する⾏為
(2) 当社、当社がライセンスを受けているライセンサーその他第三者の知的財産権、特許権、実⽤新案権、意匠権、商標権、著作権、肖像権等の財産的⼜は⼈格的な権利を侵害ZZZする⾏為⼜はこれらを侵害する恐れのある⾏為
(3) 当社⼜は第三者に不利益若しくは損害を与える⾏為⼜はその恐れのある⾏為
(4) 不当に他⼈の名誉や権利、信⽤を傷つける⾏為⼜はその恐れのある⾏為
(5) 法令⼜は条例等に違反する⾏為
(6) 公序良俗に反する⾏為若しくはその恐れのある⾏為⼜は公序良俗に反する恐れのある情報を他のユーザー⼜は第三者に提供する⾏為
(7) 犯罪⾏為、犯罪⾏為に結びつく⾏為若しくはこれを助⻑する⾏為⼜はその恐れのある⾏為
(8) 事実に反する情報⼜は事実に反する恐れのある情報を提供する⾏為
(9) 本サービスのネットワークまたはシステムに過度な負荷をかける⾏為
(10) 本サービスの全部または⼀部の複製・改変・編集・消去、他のプログラミング等との結合、リバースエンジニアリング、逆アセンブル、逆コンパイルまたはミラーサイト構築等の⾏為
(11) 当社のシステムへの不正アクセス、それに伴うプログラムコードの改ざん、位置情報の改ざん、故意に虚偽、通信機器の仕様その他アプリケーションを利⽤してのチート⾏為、コンピューターウィルスの頒布その他本サービスの正常な運営を妨げる⾏為⼜はその恐れのある⾏為
(12) スクレイピング、クローリング（クローラ、ロボットまたはスパイダー等のプログラム
を⽤いたものを含むが、これに限らない）及びその他の類似の⼿段によって本サービスにアクセスし、または本サービスに関する情報を取得する⾏為
(13) 本サービスを構成するハードウェアまたはソフトウェアへの不正アクセス⾏為、クラッキング⾏為その他の設備等に⽀障を与えるまたは与える恐れのある⾏為
(14) 本サービスの信⽤を損なう⾏為⼜はその恐れのある⾏為
(15) ⻘少年の⼼⾝及びその健全な育成に悪影響を及ぼす恐れのある⾏為
(16) 他のユーザーのアカウントの使⽤その他の⽅法により、第三者になりすまして本サービスを利⽤する⾏為
(17) 詐欺、預貯⾦⼝座及び携帯電話の違法な売買等の犯罪に結びつく⼜は結びつく恐れのある⾏為
(18) 犯罪収益に関する⾏為、テロ資⾦供与に関する⾏為⼜はその疑いがある⾏為
(19) その他当社が不適当と判断する⾏為
(20) ユーザーID及びパスワードを不正に使⽤する⾏為
(21) ⾃⼰⼜は他の利⽤者のユーザーID及びパスワードその他本サービスの情報等を第三者に提供する⾏為
(22) 当社の事前の承諾なく、本サービス上において営業、宣伝、広告、勧誘等をする⾏為
(23) 本サービス内外を問わず、当社及び本サービスに関して反社会的勢⼒を関与させる⼀切の⾏為

2. 当社は、ユーザーの⾏為が、第１項各号のいずれかに該当すると判断した場合、事前に通知することなく、以下の各号のいずれか⼜は全ての措置を講じることができます。
(1) 本サービスの利⽤制限
(2) 本契約の解除による退会処分
(3) その他当社が必要と合理的に判断する⾏為`}</Paragraph>
      <Header>第 10 条（解除）</Header>
      <Paragraph>{`1. 当社は、ユーザーが以下の各号のいずれかに該当した場合、何らの通知等を要することなく、本契約を解除し、退会させることができます。
(1) 登録情報に虚偽の情報が含まれている場合
(2) 過去に当社から退会処分を受けていた場合
(3) ユーザーの相続⼈等からユーザーが死亡した旨の連絡があった場合⼜は当社がユーザーの死亡の事実を確認できた場合
(4) 未成年が法定代理⼈の同意なく、本サービスを利⽤した場合
(5) 成年被後⾒⼈、被保佐⼈⼜は被補助⼈が、成年後⾒⼈、保佐⼈⼜は補助⼈等の同意なく、本サービスを利⽤した場合
(6) ⽀払い停⽌若しくは⽀払い不能となり、または破産⼿続開始、⺠事再⽣⼿続開始、会社更⽣⼿続開始、特別清算開始若しくはこれらに類する⼿続きの開始の申し⽴てがあった場合
(7) 6か⽉以上本サービスの利⽤が無い場合
(8) 当社からの問い合わせその他の回答を求める連絡に対して30⽇間以上応答が無い場合
(9) 当社からの要請に対し誠実に対応しない場合
(10) その他当社が不適当と判断した場合
(11) ユーザー等が禁⽌⾏為その他本規約等に違反する⾏為を⾏った場合

2. 前項各号に掲げる場合のほか、当社は、ユーザーに対して30⽇前までに事前に通知することにより、本契約を解除し、退会させることができます。
また、ユーザーが退会を希望する場合、当社が定める退会⼿続により、当⽉末⽇をもって本契約を解除し、退会することができます。

3. 前項の措置により利⽤者に⽣じた損害について、当社は利⽤料等の返還その他⼀切の責任を負わないものとします。

4. 第1 項及び第2 項の措置により退会したユーザーは、退会時に期限の利益を喪失し、直ちに、当社に対し負担する全ての債務を履⾏します。`}</Paragraph>
      <Header>第 11 条（⾮保証・免責）</Header>
      <Paragraph>{`1. 本サービスの内容について、その完全性、正確性及び有効性等について、当社は⼀切の保証をしません。また、当社は、本サービスに中断、中⽌その他の障害が⽣じないことを保証しません。

2. ユーザーが本サービスを利⽤するにあたり、本サービスから本サービスに関わる第三者が運営する他のサービス（以下「外部サービス」といいます。）に遷移する場合があります。その場合、ユーザーは、⾃らの責任と負担で外部サービスの利⽤規約等に同意の上、本サービス及び外部サービスを利⽤します。なお、外部サービスの内容について、その完全性、正確性及び有効性等について、当社は⼀切の保証をしません。

3. ユーザーが登録情報の変更を⾏わなかったことにより損害を被った場合でも、当社は⼀切の責任を負いません。

4. ユーザーは、法令の範囲内で本サービスをご利⽤ください。本サービスの利⽤に関連してユーザーが⽇本⼜は外国の法令に触れた場合でも、当社は⼀切の責任を負いません。

5. 予期しない不正アクセス等の⾏為によってユーザー情報を盗取された場合でも、それによって⽣じるユーザーの損害等に対して、当社は⼀切の責任を負いません。

6. 当社は、天災、地変、⽕災、ストライキ、通商停⽌、戦争、内乱、感染症の流⾏その他の不可抗⼒により本契約の全部⼜は⼀部に不履⾏が発⽣した場合、⼀切の責任を負いません。

7. 本サービスの利⽤に関し、ユーザーが他のユーザーとの間でトラブル（本サービス内外を問いません。）になった場合でも、当社は⼀切の責任を負わず、ユーザー間のトラブルは、当該ユーザーが⾃らの費⽤と負担において解決します。

8. 当社は、本サービスの利⽤によって利⽤者間⼜は利⽤者と第三者との間で⽣じた紛争には⼀切の責任を負わないものとし、当該紛争については、当該利⽤者が⾃らの費⽤と負担において解決するものとします。

9. 当社は、経営上の理由その他やむを得ない事由が発⽣したことにより本サービスを中⽌⼜は終了する場合には、免責されるものとします。

10. 当社は、利⽤者が本サービス上に⼊⼒した情報その他本サービスの利⽤により⽣じる情報の保管⼜は保存を⾏う義務を負わないものとし、利⽤者は、当該各情報を⾃らの責任においてバックアップその他の保管⼜は保存の措置を採るものとします。当社は、当該各情報を利⽤者が利⽤することができないことによって⽣じた損害について、⼀切の責任を負わないものとします。`}</Paragraph>
      <Header>第 12 条（損害賠償責任）</Header>
      <Paragraph>{`1. ユーザーは、本規約の違反⼜は本サービスの利⽤に関連して当社に損害を与えた場合、当社に発⽣した損害（逸失利益及び弁護⼠費⽤を含みます。）を賠償します。

2. 次項を除く本規約の他の定めにかかわらず、当社は、当社の帰責事由によりユーザーに損害を与えた場合、次の各号に定める範囲でのみその損害を賠償する責任を負います。
(1) 当社の故意⼜は重過失による場合：当該損害の全額
(2) 当社の軽過失による場合：現実かつ直接に発⽣した通常の損害（特別損害、逸失利益、間接損害及び弁護⼠費⽤を除く。）の範囲内とし、かつ当該ユーザーの直近1か⽉分の利⽤料相当額 を上限とする

3. 前項にかかわらず、ユーザーが法⼈である場合⼜は個⼈が事業として若しくは事業のために本サービスを利⽤する場合には、当社に故意⼜は重過失のない限り、本サービスに関連して当該ユーザーが被った損害につき当社は⼀切の責任を負いません。なお、当社が損害を賠償する場合は、損害発⽣⽇から直近1 年間の利⽤料⾦の累積総額を上限とします。`}</Paragraph>
      <Header>第 13 条（本サービスの廃⽌）</Header>
      <Paragraph>{`1. 当社は、当社が本サービスの提供を廃⽌すべきと合理的に判断した場合、本サービスの提供を廃⽌できます。

2. 前項の場合、当社に損害の発⽣について故意⼜は重過失がある場合を除き、当社は⼀切の責任を負いません。`}</Paragraph>
      <Header>第 14 条（秘密保持）</Header>
      <Paragraph>{`1. 利⽤者及び当社は、本サービスの提供に関して知り得た相⼿⽅の秘密情報（本サービスに関するノウハウ、当社のシステムに関する情報、技術上⼜は営業上の⼀切の秘密情報を含みます。）を、厳重かつ適正に管理するものとし、相⼿⽅の事前の書⾯による同意なく第三者（当社の関連会社及び委託先を含みます。）に開⽰、提供及び漏洩しないものとします。

2. 次の各号の情報は、秘密情報に該当しないものとします。
(1) 開⽰を受けた時、既に所有していた情報
(2) 開⽰を受けた時、既に公知であった情報⼜はその後⾃⼰の責に帰さない事由により公知となった情報
(3) 開⽰を受けた後に、第三者から合法的に取得した情報
(4) 開⽰された秘密情報によらず独⾃に開発し⼜は創作した情報
(5) 法令の定め⼜は裁判所の命令に基づき開⽰を要請された情報

3. 本利⽤契約の締結をもって、本サービスの利⽤に関して当社と利⽤者との間で締結された秘密保持に関する契約は、将来に向かって失効するものとします。

4. 第１前項の規定にかかわらず、利⽤者等及び当社は、秘密情報を本サービスの提供・利⽤のため知る必要のある役職員（雇⽤契約、委任契約⼜は業務委託契約等の契約形態を問わず⾃⼰の業務に従事する者をいいます。）、業務委託先及び弁護⼠、公認会計⼠、税理⼠その他の外部アドバイザー等であって秘密保持義務を負う者に開⽰できるものとします。また、当社は上記に加えて、当社の親会社である丸紅株式会社に合理的範囲で開⽰できるものとする。

5. 利⽤者は、事由の如何を問わず本サービスの利⽤に関する本規約その他利⽤者と当社の間の契約が終了した場合、⼜は当社から求めがあった場合、当社の指⽰に従い秘密情報の使⽤の中⽌、速やかな返還⼜は廃棄その他必要な措置を講ずるものとします。`}</Paragraph>
      <Header>第 15 条（反社会的勢⼒の排除）</Header>
      <Paragraph>{`1. ユーザー及び当社は、⾃⼰及びその役員(取締役、監査役、執⾏役⼜はこれらに準ずる者をいい、以下「役員」という)その他⾃⼰を実質的に⽀配する者が、本契約締結時点において、暴⼒団、暴⼒団員、暴⼒団準構成員、暴⼒団員・暴⼒団準構成員でなくなった⽇から５年を経過しない者、暴⼒団関係企業、総会屋等、社会運動等標ぼうゴロ、特殊知能暴⼒団等、その他これらに準ずる者（以下総称して「反社会的勢⼒」という）に該当しないこと、及び次の各号のいずれにも該当しないこと、また過去においてもそれらに該当しなかったことを表明・保証し、且つ、本契約締結⽇以降、本契約の履⾏完了までの間、⾃⼰及びその役員その他⾃⼰を実質的に⽀配する者が反社会的勢⼒に該当しないこと、及び次の各号のいずれにも該当しないことを誓約する。
(1) 反社会的勢⼒が経営を⽀配し、⼜は経営に実質的に関与していると認められる関係を有すること
(2) ⾃⼰、⾃社もしくは第三者の不正の利益を図る⽬的⼜は第三者に損害を加える⽬的をもってするなど、不当に反社会的勢⼒を利⽤していると認められる関係を有すること
(3) 反社会的勢⼒に対して資⾦等を提供し、⼜は便宜を供与する等の関与をしていると認められる関係を有すること
(4) 反社会的勢⼒と社会的に⾮難されるべき関係を有すること

2. ユーザー及び当社は、⾃ら⼜は第三者を利⽤して、暴⼒的要求⾏為、不当要求⾏為、脅迫的⾔動、暴⼒⾏為、⾵説流布・偽計による信⽤毀損⾏為、業務妨害⾏為、その他これらに準ずる⾏為を⾏わないことを誓約する。

3. ユーザー⼜は当社が前⼆項の表明・保証⼜は誓約に違反した場合、それが判明した時期の如何を問わず、相⼿⽅は何らの催告を要せず直ちに本契約を解除することができるほか、これにより被った損害の賠償を請求することができるものとする。なお、当該解除によって違反当事者に損害⼜は負担が⽣じても、当該違反当事者は相⼿⽅に対してその賠償を求めることができないものとする。

4. ユーザー⼜は当社が第1 項⼜は第2 項の表明・保証⼜は誓約に違反している疑いがあると相⼿⽅が合理的に判断する場合、相⼿⽅は、当該合理的な疑いが解消されるまでの間は本契約の履⾏を拒むことができるほか、これにより被った損害の賠償を当該合理的疑いのある当事者に請求することができるものとする。なお、当該履⾏の拒絶によって上記当事者に損害⼜は負担が⽣じても、上記当事者は相⼿⽅に対してその賠償を求めることができないものとする

5. ユーザー及び当社は、第1 項⼜は第2 項の表明・保証⼜は誓約に関する調査を相⼿⽅から求められた場合はこれに協⼒するものとする。

6. ユーザー及び当社は、本契約の締結⼜は履⾏に関し、反社会的勢⼒から不当な介⼊を受けたときには直ちにその旨を相⼿⽅に報告するものとする。`}</Paragraph>
      <Header>第 16 条（お問い合わせ対応）</Header>
      <Paragraph>{`1. 当社は、本サービスに関するユーザーからのお問い合わせに対して回答するよう努めますが、法令⼜は本規約上、当社に義務⼜は責任が発⽣する場合を除き、回答の義務を負いません。

2. 当社は、ユーザーからのお問い合わせに回答するか否かの基準を開⽰する義務を負いません。`}</Paragraph>
      <Header>第 17 条（地位の譲渡等）</Header>
      <Paragraph>{`ユーザー及び当社は、相⼿⽅の書⾯による事前の承諾なく、本契約上の地位⼜は本規約に基づく権利若しくは義務の全部⼜は⼀部につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。但し、株式譲渡若しくは事業譲渡⼜は合併、会社分割その他の組織再編についてはこの限りではありません。`}</Paragraph>
      <Header>第 18 条（個⼈情報の取り扱い）</Header>
      <Paragraph>{`本サービスにおける個⼈情報の取り扱いに関しては、当社が定める「UR（仮称）プライバシーポリシー」に基づき取り扱います。`}</Paragraph>
      <Header>第 19 条（分離可能性）</Header>
      <Paragraph>{`1. 本規約の規定の⼀部が法令に基づいて無効と判断されても、本規約の他の規定は有効とします。

2. 本規約の規定の⼀部があるユーザーとの関係で無効⼜は取消となった場合でも、本規約は他のユーザーとの関係では有効とします。`}</Paragraph>
      <Header>第 20 条（違反⾏為への対処⽅法）</Header>
      <Paragraph>{`1. ユーザーは、本規約に違反する⾏為を発⾒した場合は、当社にご連絡ください。

2. ユーザーは、本規約に違反する⾏為への当社の対処について、異議を申し⽴てることはできません。`}</Paragraph>
      <Header>第 21 条（本契約の有効期間）</Header>
      <Paragraph>{`本契約の有効期間は、本契約成⽴時からユーザーが退会するまでの間とします。なお、第8条、第10条第3項、第11条から第13条、第15条第3項及び第4項、第17条、第19条、本条、第23条及び第24条の規定は、本契約の終了後も有効に存続するものとします。`}</Paragraph>
      <Header>第 22 条（本規約の変更）</Header>
      <Paragraph>{`1. 当社は、以下の各号のいずれかに該当する場合は、⺠法第548条の4の規定に基づき本規約を随時変更できます。本規約が変更された後の本契約は、変更後の本規約が適⽤されます。
(1) 本規約の変更が、ユーザーの⼀般の利益に適合するとき
(2) 本規約の変更が、契約をした⽬的に反せず、かつ、変更の必要性、変更後の内容の相当性及びその内容その他の変更に係る事情に照らして合理的なものであるとき

2. 当社は、本規約の変更を⾏う場合は、変更後の本規約の効⼒発⽣時期を定め、効⼒発⽣時期の2週間前までに、変更後の本規約の内容及び効⼒発⽣時期をユーザーに通知、本サービス上への表⽰その他当社所定の⽅法によりユーザーに周知します。

3. 前⼆項の規定にかかわらず、前項の本規約の変更の周知後にユーザーが本サービスを利⽤した場合⼜は当社所定の期間内にユーザーが解約の⼿続をとらなかった場合、当該ユーザーは本規約の変更に同意したものとします。`}</Paragraph>
      <Header>第 23 条（準拠法）</Header>
      <Paragraph>{`本規約に関する準拠法は、全て⽇本国の法令が適⽤されます。`}</Paragraph>
      <Header>第 24 条（合意管轄）</Header>
      <Paragraph>{`ユーザーと当社との間における⼀切の訴訟は、東京地⽅裁判所を第⼀審の専属的合意管轄裁判所とします。`}</Paragraph>
      <Header>第 25 条（その他）</Header>
      <Paragraph>{`1. ユーザーは、本規約に定めのない事項について、当社が細⽬等を別途定めた場合、これに従います。この場合、当該細⽬等は、本規約と⼀体をなします。

2. 細⽬等は、当社所定の箇所に掲載した時点より効⼒を⽣じます。

3. 細⽬等と本規約の内容に⽭盾抵触がある場合、本規約が優先します。`}</Paragraph>
      <Footnote>{`附則

2024年2月1日⽇制定・施⾏`}</Footnote>
    </TextDocument>
  );
}

export default TermsOfService;
